import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormCaptureFields } from '@/components/vsleads/types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { VideoSelectorV2 } from '@/components/shared/VideoSelectorV2';
import { Settings } from 'lucide-react';

interface VideoTabProps {
  form: UseFormReturn<FormCaptureFields>;
}

export function VideoTab({ form }: VideoTabProps) {
  useLanguage();
  const videoId = form.watch('videoId');
  const isActive = form.watch('is_active');

  return (
    <div className="space-y-6">
      {/* Card: Vídeo */}
      <Card className="border-0 shadow-md">
        <CardHeader>
          <CardTitle className="text-base">{translateInterfaceText("Vídeo")}</CardTitle>
          <CardDescription>
            {translateInterfaceText("Selecione o vídeo onde a captura será exibida")}</CardDescription>
        </CardHeader>
        <CardContent>
          <div>
            <Label htmlFor="video-select">{translateInterfaceText("Selecione um vídeo *")}</Label>
          <VideoSelectorV2
            value={videoId}
            onChange={(value) => form.setValue('videoId', value || '', { shouldDirty: true })}
            placeholder={translateInterfaceText("Selecione o vídeo para a captura")}
            allowPin={true}
            showTabs={true}
          />
          </div>
        </CardContent>
      </Card>

      {/* Card: Status da Estratégia - Premium */}
      <div className="space-y-4">
        <div className="bg-[#F7F8FE] rounded-xl p-4 space-y-3 border border-[#E2E8F0] shadow-[0_2px_8px_rgba(0,0,0,0.03)]">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Settings 
                className={`w-5 h-5 transition-colors duration-200 ${
                  isActive ? 'text-[#2D6CF6]' : 'text-[#94A3B8]'
                }`} 
                strokeWidth={2}
              />
              <span className="text-sm font-medium text-[#1A1A1A]">
                {translateInterfaceText("Estratégia de Captura")}</span>
            </div>
            <Switch
              id="is-active"
              checked={isActive}
              onCheckedChange={(checked) =>
                form.setValue('is_active', checked, { shouldDirty: true })
              }
              className="data-[state=checked]:bg-[#3072FF]"
            />
          </div>
          
          <p className="text-[13px] text-[#6B7280] leading-relaxed pl-7">
            {translateInterfaceText("Ative para exibir o formulário de captura de dados neste vídeo no momento configurado. Quando ativo, o formulário será exibido automaticamente.")}</p>
        </div>
        
        <div className="h-px bg-[#ECEEF3]" />
      </div>
    </div>
  );
}
